exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-wrap {\n  width: inherit;\n}\n\n@media (max-width: 1200px) {\n  .text-wrap {\n    width: 95px;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/history-params.scss
// module id = 575
// module chunks = 0